import axios from "axios";
import { base_url, getToken } from "../../config/config";

const getHeaders = () => {
  const token = getToken();
  return {
    "Content-Type": "application/json",
    authorization: `Bearer ${token}`,
  };
};

// ============================================
// WAREHOUSE APIs
// ============================================

export const createWarehouse = async (data) => {
  try {
    const response = await axios.post(`${base_url}/v1/warehouse`, data, {
      headers: getHeaders(),
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const getAllWarehouses = async () => {
  try {
    const response = await axios.get(`${base_url}/v1/warehouses`, {
      headers: getHeaders(),
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const getWarehouseById = async (id) => {
  try {
    const response = await axios.get(`${base_url}/v1/warehouse/${id}`, {
      headers: getHeaders(),
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const updateWarehouse = async (id, data) => {
  try {
    const response = await axios.put(`${base_url}/v1/warehouse/${id}`, data, {
      headers: getHeaders(),
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const deleteWarehouse = async (id) => {
  try {
    const response = await axios.delete(`${base_url}/v1/warehouse/${id}`, {
      headers: getHeaders(),
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const saveWarehouseLayout = async (id, layout) => {
  try {
    const response = await axios.post(
      `${base_url}/v1/warehouse/${id}/layout`,
      { layout },
      {
        headers: getHeaders(),
      }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const getWarehouseLayout = async (id) => {
  try {
    const response = await axios.get(
      `${base_url}/v1/warehouse/${id}/layout`,
      {
        headers: getHeaders(),
      }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const getWarehouseAnalytics = async (id) => {
  try {
    const response = await axios.get(
      `${base_url}/v1/warehouse/${id}/analytics`,
      {
        headers: getHeaders(),
      }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// ============================================
// ZONE APIs
// ============================================

export const createZone = async (data) => {
  try {
    const response = await axios.post(`${base_url}/v1/zone`, data, {
      headers: getHeaders(),
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const getZonesByWarehouse = async (warehouseId) => {
  try {
    const response = await axios.get(
      `${base_url}/v1/warehouse/${warehouseId}/zones`,
      {
        headers: getHeaders(),
      }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const updateZone = async (id, data) => {
  try {
    const response = await axios.put(`${base_url}/v1/zone/${id}`, data, {
      headers: getHeaders(),
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const deleteZone = async (id) => {
  try {
    const response = await axios.delete(`${base_url}/v1/zone/${id}`, {
      headers: getHeaders(),
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// ============================================
// RACK APIs
// ============================================

export const createRack = async (data) => {
  try {
    const response = await axios.post(`${base_url}/v1/rack`, data, {
      headers: getHeaders(),
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const getRacksByWarehouse = async (warehouseId) => {
  try {
    const response = await axios.get(
      `${base_url}/v1/warehouse/${warehouseId}/racks`,
      {
        headers: getHeaders(),
      }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const updateRack = async (id, data) => {
  try {
    const response = await axios.put(`${base_url}/v1/rack/${id}`, data, {
      headers: getHeaders(),
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const deleteRack = async (id) => {
  try {
    const response = await axios.delete(`${base_url}/v1/rack/${id}`, {
      headers: getHeaders(),
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const generateRackPositions = async (rackId) => {
  try {
    const response = await axios.post(
      `${base_url}/v1/rack/${rackId}/generate-positions`,
      {},
      {
        headers: getHeaders(),
      }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

// ============================================
// POSITION APIs
// ============================================

export const getAvailablePositions = async (warehouseId) => {
  try {
    const response = await axios.get(
      `${base_url}/v1/positions/available?warehouse=${warehouseId}`,
      {
        headers: getHeaders(),
      }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const assignProductToPosition = async (positionId, productId, quantity) => {
  try {
    const response = await axios.post(
      `${base_url}/v1/position/${positionId}/assign`,
      { productId, quantity },
      {
        headers: getHeaders(),
      }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};
